<template>
  <div>
    <money
      class="form-control"
      v-model="formattedValue"
      v-bind="money"
      :readonly="readonly"
    ></money>
    <!-- {{formattedValue}} -->
    <!-- {{value}} -->
    <!-- {{placeholder}} -->
  </div>
</template>

<script>
import { Money } from "v-money";

export default {
  name: "BaseInputNumeric",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    placeholder: String,
    readonly: Boolean,
  },
  components: {
    Money,
  },
  data() {
    return {
      formattedValue: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
    };
  },
  created() {
    this.formattedValue = this.value;
  },
  computed: {},
  methods: {},
  watch: {
    formattedValue() {
      let newValue = parseFloat(this.formattedValue);
      // console.log(this.formattedValue);
      // console.log(newValue);
      this.$emit("update:value", newValue);
    },
    value() {
      // if (this.value) {
        this.formattedValue = this.value;
      // }
      this.$forceUpdate();
    },
  },
};
</script>
